import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { PageService } from '@clooper/core';
import { faPlus } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent  {

 @Input() faqs: any[] = [
    {
      title: 'What does Clooper do?',
      content: `<p>Clooper helps business travellers find and book high-quality hotels and serviced apartments. You can choose from a wide range of properties in over 25000 locations worldwide. It’s easy to compare prices and amenities. Plus, you have access to a team of experts who can help you find the perfect place for your needs. Because Clooper negotiates preferential rates with its trusted partners, you can be confident that you’re getting the best possible price. You will have a comfortable and safe stay, no matter where you travel. Sign up and book in 3 easy steps. </p>

     `,
    },
    {
      title: 'What Does Clooper (The platform) Do?',
      content: `<p>Clooper helps businesses to easily fulfil their short term  accommodation requirements by finding and booking high quality serviced accommodation in 3 simple steps. So you can rest assured that you and your staff are in safe hands.
      The goal is peace of mind. To make your team feel so comfortable, to feel they are home.</p>`,
    },
    // {
    //   title: 'How does Clooper keep my data secure?',
    //   content: `<p>Clooper never shares your details with any third-party providers unless you have consented for us to do so. Please see Clooper’s privacy policy for more information.</p>`
    // },
    // {
    //   title: 'Who is Clooper for?',
    //   content: `

    //   <p> Clooper is for anyone looking for a place to call home, whether for Serviced Short Lets or Long Lets. Clooper not only allows you to search through a fantastic selection of high-quality properties, but our trusted algorithms, artificial intelligence, and machine learning are constantly helping you in getting matched to properties faster. <p>

    //     `
    // },
    {
      title: 'Who Can I Contact If I Need Help?',
      content: `<p>You can contact us through our friendly Customer Success Team or by email at <a href="mailto:customersuccess@clooper.com">customersuccess@clooper.com</a>.</p>`,
    },
    {
      title: 'How do I cancel my reservation?',
      content: `<p></p>`,
    },
  ];

  @Input() isLight: boolean = true;
  @Input() noFloat: boolean = false;

  icons = {
    plus: faPlus,
  };

  constructor(
    @Inject(DOCUMENT) private document: Document,
    pageService: PageService
  ) {
    // pageService.updateTitle(`Frequently Asked Questions | Clooper`)
    pageService.updateDescription(`Learn more from our FAQs including how to book serviced apartments & hotels, how to find the best deals, and how to make the most of your business travel.

    `);
    pageService.updateMetaKeywords(`Clooper, frequenly asked questions, FAQs`);
    this.createCanonicalURL();
  }

  createCanonicalURL() {
    let link: HTMLLinkElement = this.document.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.document.head.appendChild(link);
    link.setAttribute('href', this.document.URL);
  }

  openAccordion(id: string) {
    this.document.getElementById(id)?.classList.toggle('active');
  }

}
